import { render, staticRenderFns } from "./MarketContactCard.vue?vue&type=template&id=13f2ea36&scoped=true"
import script from "./MarketContactCard.vue?vue&type=script&lang=js"
export * from "./MarketContactCard.vue?vue&type=script&lang=js"
import style0 from "./MarketContactCard.vue?vue&type=style&index=0&id=13f2ea36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2ea36",
  null
  
)

export default component.exports